import React, { Component } from 'react';
import Styles from './styles.module.css';
import { Link } from 'react-router-dom';

export default class VideoTile extends Component<{ video:string, header: string, text: string, link?:string }, {image:string}>{
    constructor(props: any) {
        super(props);
    }
    render() {
        return (
            <Link to={this.props.link || ''}>
            <div className={Styles.tile}>
                <div className={Styles.shade}/>
                <video src={this.props.video} autoPlay={true} controls={false} loop={true} playsInline={true} muted={true}/>
                <div className={Styles.content}>
                    <div className={Styles.header}>{this.props.header}</div>
                    <div className={Styles.text}>{this.props.text}</div>
                </div>
            </div>
            </Link>
        )
    }
}